import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { IGetRecommendedProfessionalsParams } from '../recommendedProfessionalsApi';
import { recommendedProfessionalsService } from '../recommendedProfessionalsService';
import { IRecommendedProfessional } from '../recommendedProfessionalsTypes';

type TUseRecommendedProfessionalsParams = IGetRecommendedProfessionalsParams & {
  enabled: boolean;
};

export function useRecommendedProfessionals(params: TUseRecommendedProfessionalsParams) {
  const dispatch = useDispatch();
  const query = useQuery<IRecommendedProfessional[]>({
    queryKey: ['recommended-professionals', params],
    queryFn: () => recommendedProfessionalsService.getRecommendedProfessionals(params),
    enabled: params.enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (query.data) {
      dispatch({ type: 'SET_RECOMMENDED_PROFESSIONALS', payload: query.data });
    }
  }, [query.data, dispatch]);

  return query;
}
